import React, { FC, PropsWithChildren, useCallback } from 'react';
import { UploadRequestOption } from 'rc-upload/es/interface';
import {
  ApiErrorResponse,
  SampleDataSubjectFormDataType,
  useMutateSampleUpload,
} from '@atlas-frontend/sdk';
import styled from 'styled-components';
import { Upload } from 'antd';
import { SampleDataObjectType } from './SampleSearch';

interface SampleUploadProps extends PropsWithChildren {
  id: number;
  type: SampleDataObjectType;
  onError?: (error: ApiErrorResponse) => void;
  onPendingChange?: (pending: boolean) => void;
  onSuccess?: (samples: SampleDataSubjectFormDataType[]) => Promise<void>;
  valueDate: string;
}

export const SampleUpload: FC<SampleUploadProps> = ({
  children,
  id,
  type,
  onError,
  onPendingChange,
  onSuccess,
  valueDate,
}) => {
  const { mutateAsync } = useMutateSampleUpload();

  const handleUpload = useCallback(
    async (options: UploadRequestOption) => {
      const { file } = options;
      onPendingChange?.(true);
      try {
        const samples = await mutateAsync({ file, id, type, valueDate });
        await onSuccess?.(samples);
        options.onSuccess?.(samples);
      } catch (error) {
        const apiError = error as ApiErrorResponse;
        onError?.(apiError);
        options.onError?.(apiError);
      } finally {
        onPendingChange?.(false);
      }
    },
    [id, mutateAsync, onError, onPendingChange, onSuccess, type, valueDate],
  );

  return (
    <StyledUpload customRequest={handleUpload} showUploadList={false}>
      {children}
    </StyledUpload>
  );
};

const StyledUpload = styled(Upload)`
  color: inherit;
`;
